import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (value: boolean) => void;
}

/**
 * Свёрнута ли боковая колонка.
 *
 * Запоминается в localStorage: это удобство конкретного человека на
 * конкретном устройстве, а не данные, и на сервере ему делать нечего.
 */
export const useSidebar = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed: false,
      toggle: () => {
        set((state) => ({ collapsed: !state.collapsed }));
      },
      setCollapsed: (value) => {
        set({ collapsed: value });
      },
    }),
    { name: 'flowdo.sidebar' },
  ),
);
